module.exports = __webpack_public_path__ + "img/lang-23.ba4a63ae.jpg";